// src/plugins/axios.js
import Vue from 'vue'
import axios from 'axios'

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 600000,
  withCredentials: true
})

axiosInstance.interceptors.request.use(
  (config) => {
    const isAuthenticated = Vue.prototype.$storage.getUniversal('isAuthenticated')
    if (!isAuthenticated) {
      console.log('Not authenticated')
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Add response interceptor to handle 401 errors
axiosInstance.interceptors.response.use(
  (response) => {
    return response
  },
  async (error) => {
    if (error.response && error.response.status === 401) {
      try {
        await axiosInstance.post('/auth/v3/logout')
        window.location.reload()
      } catch (logoutError) {
        console.error('Error during logout:', logoutError)
      }
      localStorage.clear()
      this.$router.push('/login')
      console.log('Redirected to login')
    }

    return Promise.reject(error)
  }
)

Vue.prototype.$axios = axiosInstance
